import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const dueIn = (iso) => {
  const ms = new Date(iso) - Date.now();
  const a = Math.abs(ms);
  const d = Math.floor(a / 864e5), h = Math.floor((a % 864e5) / 36e5), m = Math.floor((a % 36e5) / 6e4);
  const s = d ? `${d}d ${h}h` : `${h}h ${m}m`;
  return ms < 0 ? `overdue by ${s}` : `due in ${s}`;
};

export const Pick = ({ value, onChange, options, testid, className = "w-40", placeholder }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={`bg-white ${className}`} data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>{options.map((o) => { const [v, l] = Array.isArray(o) ? o : [o, o.charAt(0).toUpperCase() + o.slice(1).replace(/_/g, " ")]; return <SelectItem key={v} value={v}>{l}</SelectItem>; })}</SelectContent>
  </Select>
);

export const Card = ({ children, testid, className = "" }) => <div className={`surface space-y-3 p-4 sm:p-5 ${className}`} data-testid={testid}>{children}</div>;

export const LEVEL_STYLE = { critical: "border-rose-200 bg-rose-50 text-rose-800", warning: "border-amber-200 bg-amber-50 text-amber-900", info: "border-sky-100 bg-sky-50/70 text-sky-900",
  high: "border-rose-200 bg-rose-50 text-rose-800", medium: "border-amber-200 bg-amber-50 text-amber-900", low: "border-emerald-200 bg-emerald-50 text-emerald-800" };

export const Level = ({ level, testid }) => <span data-testid={testid} className={`inline-flex rounded-full border px-2.5 py-0.5 text-[11px] font-semibold capitalize ${LEVEL_STYLE[level] || LEVEL_STYLE.info}`}>{level}</span>;

export const History = ({ items }) => (
  <details className="text-xs text-slate-500"><summary className="cursor-pointer select-none">History ({items.length})</summary>
    <ul className="mt-1 space-y-0.5">{items.map((h, i) => <li key={i}>{new Date(h.at).toLocaleString()} — {(h.status || "note").replace(/_/g, " ")}{h.note && `: ${h.note}`}</li>)}</ul>
  </details>
);
